<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-3" [hidden]='true'>
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="Search"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-3" [hidden]='true'>
      <div class="relative flmid">
        <select class="form-control" [(ngModel)]="cost" (change)="onStatusChange()" name="cost">
          <option disabled selected [ngValue]="''" translate>lblSelectCostType</option>
          <option *ngFor="let costType of costTypeData" [ngValue]="costType.name">
            {{costType.name}}
          </option>
        </select>
      </div>
    </div>
    <div class="col-2">
      <label for="template-make" translate>lblMake</label>
      <div class='lbl-info'>
          <ng-select placeholder="{{ 'lblSelectMake' | translate }}" [(ngModel)]="brandCode">
              <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                  {{type.brandCode}}</ng-option>
          </ng-select>
      </div>
  </div>
  <div class="col-2">
      <label for="service" translate>lblPartNumber
          <strong class="mlt6 required"> * </strong>
      </label>
      <div class='lbl-info'>
          <input class="form-control mb-2" [(ngModel)]="partNumber" placeholder="{{ 'lblEnterPartNumber' | translate }}" maxlength="20" (keyup.enter)="getParts()">
      </div>
  </div>
  <div class="col-2">
      <label for="service" translate>lblDescription
          <strong class="mlt6 required"> * </strong>
      </label>
      <div class='lbl-info'>
          <input class="form-control mb-2" [(ngModel)]="partDescription" placeholder="{{ 'lblDescription' | translate }}" maxlength="50" (keyup.enter)="getParts()">
      </div>
  </div>
  <div class="col-auto">
    <button class="btn btn-primary mt-22" type="button" (click)="getParts()">
        <em class="fa fa-search"></em> Search
    </button>
</div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" type="reset" aria-label="Center Align" class="btn btn-primary mt-22" translate (click)="onAdd()">
        lblAddParts
      </button>
    </div>
  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblParts</h4>
        </div>
        <div class="table-responsive">


          <table class="tablest1">
            <thead>
              <tr>
                <th style="width:55px" scope="col">#</th>
                <th style="width:15%" scope="col" sortable="partNumber" (sort)="onSort($event)" translate>
                  lblPartNumber
                </th>
                <th style="width:15%" scope="col" translate [hidden]='true'>lblCostType</th>
                <th style="width:15%" scope="col" translate>lblDescription</th>
                <th style="width:15%" class="text-right" scope="col" sortable="unitPrice" (sort)="onSort($event)" translate>
                  lblUnitPrice
                </th>
                <th style="width:15%" scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)" translate>
                  lblActive
                </th>
                <th style="width:75px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="partsList?.length > 0; else load_else">
                <tr *ngFor="let parts of partsList; let i = index">
                  <td>{{ parts.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="parts.partNumber" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td [hidden]='true'>
                    <ngb-highlight [result]="parts.costType" [term]="pService.searchTerm"></ngb-highlight>
                  </td>

                  <td>
                    <ngb-highlight [result]="parts.description" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>

                  <td class="text-right">
                    <ngb-highlight [result]="parts.unitPrice | number: '1.2-2'" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="parts.isActive"></em>
                    <em class="fas fa-times text-danger" *ngIf="!parts.isActive"></em>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit && parts?.editable"
                        (click)="editPartsDetails(parts.partNumber,parts.id)">
                        <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>

                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$ | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{ item.label }}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{
              pService.total$ | async
              }}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>